<lib-form-field-container [kind]="FormContainerKind.None">
    <ng-content
        label
        select="[label]"></ng-content>

    <ng-container readOnly>
        <div class="d-flex flex-row">
            @for (rating of starLevels; track rating) {
                <ng-container *ngTemplateOutlet="starIcon; context: { $implicit: rating }"></ng-container>
            }
        </div>
    </ng-container>

    <div
        class="d-flex flex-row sb-form-field-star-rating"
        role="group"
        [attr.aria-labelledby]="ariaLabel ? null : formFieldID + '-label'"
        [attr.aria-describedby]="formFieldID + '-description ' + formFieldID + '-error'"
        [attr.aria-label]="ariaLabel || null"
        [attr.aria-invalid]="formControl.isDirty && formControl.errors ? 'true' : null"
        [attr.aria-required]="formControl.isRequired">
        @for (rating of starLevels; track rating) {
            @if (!isDisabled) {
                <button
                    type="button"
                    class="sb-star-rating-button"
                    [attr.aria-label]="rating === 1 ? '1 star' : rating + ' stars'"
                    [attr.aria-pressed]="formControl.value === rating"
                    (click)="StarClicked(rating)"
                    (mouseenter)="StarHovered(rating)"
                    (mouseleave)="MouseLeave()">
                    <ng-container *ngTemplateOutlet="starIcon; context: { $implicit: rating }"></ng-container>
                </button>
            } @else {
                <ng-container *ngTemplateOutlet="starIcon; context: { $implicit: rating }"></ng-container>
            }
        }
    </div>

    <ng-container supportingText>
        <ng-content select="[supportingText]"></ng-content>
    </ng-container>
</lib-form-field-container>

<ng-template
    #starIcon
    let-rating>
    @if (starHovered != null) {
        <div class="sb-star-container">
            <!-- hover state -->
            @if (rating <= starHovered) {
                <span
                    class="sb-star-hover"
                    [innerHTML]="Icon.StarComponent.Hover.Path | trustHtml"></span>
            } @else {
                <span
                    class="sb-star-default"
                    [innerHTML]="Icon.StarComponent.Default.Path | trustHtml"></span>
            }
        </div>
    } @else {
        <div class="sb-star-container">
            <!-- not hovering -->
            @if (currentRating != null && rating <= currentRating) {
                <span
                    [ngClass]="{ 'sb-star-readOnly': isDisabled, 'sb-star-selected': !isDisabled }"
                    [innerHTML]="Icon.StarComponent.Filled.Path | trustHtml"></span>
            } @else {
                <span
                    class="sb-star-default"
                    [innerHTML]="Icon.StarComponent.Default.Path | trustHtml"></span>
            }
        </div>
    }
</ng-template>
